import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import WaiverForm from '@/app/userActivityWaiver/WaiverForm';

import Page from '@/components/layout/Page';
import PageLoading from '@/components/layout/PageLoading';
import BackButton from '@/components/common/BackButton';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

import { useApplication } from '@/data/application';
import { useCoachSelf } from '@/data/coach';
import { useCoachActivity } from '@/data/coachActivity';
import { useActivitiesV2 } from '@/data/activity';

const APPLICATION_STEP_KEY = 'waiver';

const CoachActivityWaiverPage = () => {
  const coach = useCoachSelf();
  const params = useParams();
  const coachActivity = useCoachActivity(params.coachActivityId);
  const applicationStructure = useApplication({
    coachActivityId: params.coachActivityId
  });
  const activities = useActivitiesV2();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (coach.isLoading && !coach.data) {
    return <PageLoading />;
  }
  if (coachActivity.isLoading && !coachActivity.data) {
    return <PageLoading />;
  }
  if (applicationStructure.isLoading && !applicationStructure.data) {
    return <PageLoading />;
  }
  if (activities.isLoading && !activities.data) {
    return <PageLoading />;
  }

  const step = applicationStructure.data.steps.find(
    (step) => step.key === APPLICATION_STEP_KEY
  );

  const handleSuccess = () => {
    navigate(step.nextStepLink);
  };

  const handleNextStep = () => {
    navigate(step.nextStepLink);
  };

  return (
    <Page>
      <BackButton to={`/application/${params.coachActivityId}`} />
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Waiver ({coachActivity.data.activity.title})</CardTitle>
        </CardHeader>
        <CardContent>
          <WaiverForm
            onSuccess={handleSuccess}
            onNextStep={handleNextStep}
            isComplete={step.isComplete}
            activityId={coachActivity.data.activityId}
          />
        </CardContent>
      </Card>
      <div className="flex justify-center py-8"></div>
    </Page>
  );
};

export default CoachActivityWaiverPage;
